(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const shareTriggers = document.querySelectorAll('.c-blog-post__share-trigger');
    
    shareTriggers.forEach(trigger => {
      const menu = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!menu) return;
      
      // Toggle menu on click
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', !isExpanded);
        menu.hidden = isExpanded;
        menu.setAttribute('aria-hidden', isExpanded);
        
        if (!isExpanded) {
          // Focus first menu item when opening
          const firstMenuItem = menu.querySelector('a[role="menuitem"]');
          if (firstMenuItem) {
            firstMenuItem.focus();
          }
        }
      });
      
      // Close menu on escape key
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          menu.hidden = true;
          menu.setAttribute('aria-hidden', 'true');
          trigger.focus();
        }
      });
      
      // Close menu when clicking outside
      document.addEventListener('click', function(e) {
        if (!trigger.contains(e.target) && !menu.contains(e.target)) {
          trigger.setAttribute('aria-expanded', 'false');
          menu.hidden = true;
          menu.setAttribute('aria-hidden', 'true');
        }
      });
      
      // Handle keyboard navigation within menu
      menu.addEventListener('keydown', function(e) {
        const menuItems = Array.from(menu.querySelectorAll('a[role="menuitem"]'));
        const currentIndex = menuItems.indexOf(e.target);
        
        switch(e.key) {
          case 'ArrowRight':
            e.preventDefault();
            const nextIndex = (currentIndex + 1) % menuItems.length;
            menuItems[nextIndex].focus();
            break;
          case 'ArrowLeft':
            e.preventDefault();
            const prevIndex = currentIndex === 0 ? menuItems.length - 1 : currentIndex - 1;
            menuItems[prevIndex].focus();
            break;
          case 'Escape':
            e.preventDefault();
            trigger.setAttribute('aria-expanded', 'false');
            menu.hidden = true;
            menu.setAttribute('aria-hidden', 'true');
            trigger.focus();
            break;
          case 'Tab':
            // Close menu on tab
            trigger.setAttribute('aria-expanded', 'false');
            menu.hidden = true;
            menu.setAttribute('aria-hidden', 'true');
            break;
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
